import "../css/style.scss"

document.getElementById('hamburger-menu').onclick = function() {
    var navList = document.getElementById('nav-list');
    if (navList.style.display === 'block' || navList.style.display === 'flex') {
        navList.style.display = 'none';
    } else {
        navList.style.display = 'flex';
    }
};
